export default "__VITE_ASSET__B$bpfYpD__"